export var baseModalUrl = '//ecom.wix.com';
export var ModalType;
(function (ModalType) {
    ModalType["SetShipping"] = "SetShipping";
    ModalType["SetPayment"] = "SetPayment";
    ModalType["UpgradeToPremium"] = "UpgradeToPremium";
    ModalType["NotInLiveSite"] = "NotInLiveSite";
    ModalType["CantShipToDestination"] = "CantShipToDestination";
    ModalType["NoOnlinePayments"] = "NoOnlinePayments";
    ModalType["Subscriptions"] = "subscriptions";
    ModalType["HighArpuSubscriptions"] = "highArpuSubscriptions";
})(ModalType || (ModalType = {}));
//# sourceMappingURL=constants.js.map